import React from "react";
import { Form, Row, Col, Divider, Typography, Select } from "antd";
import { c_TipoDeRelación } from "../../../SATCatalogos/index";
import SelectFactura from "../../Inputs/SelectFactura";

const { Title, Text } = Typography;
const { Option } = Select;

const RelacionFacturasSection = (props) => {

    const { onSelectFactura = () => {}, onDeselectFactura = () => {} } = props
    const form = Form.useFormInstance()

    const handleSelect = (factura_id) => {
        const current = form.getFieldValue("facturas_ids") ?? []
        if (!current.includes(factura_id))
            form.setFieldValue("facturas_ids", [...current, factura_id])
        onSelectFactura(factura_id)
    }

    const handleDeselect = (factura_id) => {
        const current = form.getFieldValue("facturas_ids") ?? []
        form.setFieldValue("facturas_ids", current.filter(id => id !== factura_id))
        onDeselectFactura(factura_id)
    }

    return (
        <>
            <Row>
                <Divider orientation="left" style={{ margin: "12px 0 24px 0 " }} />
                <Title level={5}>Información de Relación a Facturas</Title>
            </Row>
            <Form.Item name="facturas_ids" hidden initialValue={[]} />
            <Row className="mb-1" gutter={[16, 16]}>
                <Col xs={20} md={8}>
                    <Form.Item
                        name={["CfdiRelacionados", "UUID"]}
                        label="Factura a relacionar"
                        rules={[
                            {
                                required: false,
                                message: "Seleccione la factura a relacionar",
                            },
                        ]}
                    >
                        <SelectFactura
                            params={{cliente_id: props.clienteId}}
                            placeholder="Seleccione la factura a relacionar"
                            onSelect={handleSelect}
                            onDeselect={handleDeselect}
                            allowClear={false}
                        />
                    </Form.Item>
                </Col>
                <Col xs={20} md={8}>
                    <Form.Item
                        name={["CfdiRelacionados", "TipoRelacion"]}
                        label="Tipo de Relación"
                        rules={[
                            {
                                required: true,
                                message: "Seleccione el tipo de relación",
                            },
                        ]}
                    >
                        <Select placeholder="Seleccione el tipo de relación" filterOption={false}>
                            {c_TipoDeRelación.map(({ tipo_relacion, descripción }) => (
                                <Option key={tipo_relacion} value={tipo_relacion}>
                                    <strong>{tipo_relacion}</strong> -{" "}
                                    <Text style={{ wordWrap: "break-word" }}>{descripción}</Text>
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};

export default RelacionFacturasSection;
